/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */
import * as React from "react";
import { Link } from "react-router-dom";
import { EmployeesRoleSidebar } from "~/components/Employees/EmployeesRoleSidebar";
import { ColumnProps } from "~/components/Tables/types";
import { Employee } from "~/models";
import { ROUTES } from "~/routing";
import { getEmployeeStatusColor } from "~/tools/display/displayEmployeeColor";

export const EmployeesListColumns = (
  refetch: () => Promise<void>
): ColumnProps<Employee>[] => [
  {
    Header: "First Name",
    accessor: "firstName",
    width: "25%",
    Cell: ({ row }) => {
      return (
        <Link to={`${ROUTES.employees.index}/${row.original.id}`}>
          {row.original.firstName}
        </Link>
      );
    },
  },
  {
    Header: "Last Name",
    accessor: "lastName",
    width: "35%",
    Cell: ({ row }) => {
      return (
        <Link to={`${ROUTES.employees.index}/${row.original.id}`}>
          {row.original.lastName}
        </Link>
      );
    },
  },
  {
    Header: "Email",
    accessor: "email",
    width: "30%",
    Cell: ({ row }) => {
      return (
        <Link to={`${ROUTES.employees.index}/${row.original.id}`}>
          {row.original.email}
        </Link>
      );
    },
  },
  {
    Header: "Role",
    accessor: "permission",
    width: "30%",
    Cell: ({ row }) => row?.original?.permission?.replace("_", " ") || "-",
  },
  {
    Header: "Active",
    accessor: "status",
    Cell: ({ row }) => (
      <span style={{ color: getEmployeeStatusColor(row?.original) }}>
        {row.original.status === "deactivated" ? "No" : "Yes"}
      </span>
    ),
  },
  {
    Header: "Action",
    accessor: "action",
    hasLeftBorder: true,
    disableSortBy: true,
    Cell: ({ row }) => {
      return <EmployeesRoleSidebar refetch={refetch} employee={row.original} />;
    },
  },
];
